import { Org } from 'domain-types';

export const isOrgReadOnly = (org?: Pick<Org, 'stripe'> | null) =>
  org?.stripe?.accessMode === 'read_only';